import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import LeftComponent from "../components/LeftComponent";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Universities from "../components/Universities";
import {
  deleteInvoice,
  listInvoices,
  listInvoicesTotal,
} from "../actions/invoiceActions";
import { format, set } from "date-fns";
import ReactPaginate from "react-paginate";
import Country from "../components/Country";
import Branch from "../components/Branch";
import Partner from "../components/Partner";
import "../css/invoiceScreen.css";
import { invoiceSearchJson } from "../models/invoiceModel";
import { INVOICE_DELETE_RESET } from "../constants/invoiceConstants";
import SubAgent from "../components/SubAgent";
import { InvoiceStatusJson } from "../data/enum";

export default function InvoiceScreen(props) {
  const [chkVal, setChkVal] = useState("allinvoices");
  const [records, setRecords] = useState([]);

  const dispatch = useDispatch();

  const [invoiceData, setInvoiceData] = useState(invoiceSearchJson);

  const setInvoices = (e) => {
    e.preventDefault();
    setInvoiceData({ ...invoiceData, [e.target.name]: e.target.value });
    // applyFilter();
  };

  const invoiceList = useSelector((state) => state.invoiceList);
  const { loading, invoices, error } = invoiceList;

  const invoiceListTotal = useSelector((state) => state.invoiceListTotal);
  const {
    loading: loadingTotal,
    invoicesTotal,
    error: errorTotal,
  } = invoiceListTotal;

  const invoiceDelete = useSelector((state) => state.invoiceDelete);
  const {
    loading: loadingDelete,
    success: successDelete,
    error: errorDelete,
  } = invoiceDelete;

  const userDetails = useSelector((state) => state.userDetails);
  const { user } = userDetails;

  const applyFilter = () => {
    dispatch(listInvoices({ ...invoiceData }));
    dispatch(listInvoicesTotal({ ...invoiceData }));
  };

  const handleChange = (e) => {
    e.preventDefault();
    setInvoiceData({ ...invoiceData, [e.target.name]: e.target.value });
  };

  const applyOverdueInvoice = (e) => {
    var e = e || window.event;
    e.preventDefault();
    setChkVal("overdue");
    const date = format(new Date(0), "yyyy-MM-dd");
    const cdate = new Date();
    const timePortion = cdate.getTime() % (60 * 60 * 24);
    const ctdate = format(new Date(cdate - timePortion), "yyyy-MM-dd");
    setInvoiceData({
      ...invoiceData,
      invoiceFrom: date,
      invoiceTo: ctdate,
      invoiceStatus: "3",
    });
    applyFilter(e);
  };

  const applyDueTodayInvoice = (e) => {
    e.preventDefault();
    setChkVal("duetoday");
    const ctdate = format(new Date(), "yyyy-MM-dd");
    setInvoiceData({
      ...invoiceData,
      invoiceFrom: ctdate,
      invoiceTo: ctdate,
      invoiceStatus: "",
    });

    applyFilter();
  };

  const applyAllInvoice = (e) => {
    e.preventDefault();
    setChkVal("allinvoices");
    setInvoiceData({
      ...invoiceData,
      invoiceFrom: "",
      invoiceTo: "",
      invoiceStatus: "",
    });
    applyFilter();
  };

  const applySearchFilter = () => {
    setInvoiceData({
      ...invoiceData,
      pageNo: 1,
    });
    applyFilter();
  };

  const applyPageFilter = (e) => {
    // console.log(e.selected)
    // var e = e || window.event;
    setInvoiceData({
      ...invoiceData,
      pageNo: 1 + e.selected,
    });
    applyFilter();
  };

  const resetFilter = (e) => {
    e.preventDefault();
    setInvoiceData({
      ...invoiceSearchJson,
    });
    setChkVal("allinvoices");
    applyFilter();
  };

  const handleDeleteInvoice = (e, invoiceId) => {
    e.preventDefault();

    if (window.confirm("Are you sure?")) {
      dispatch(deleteInvoice(invoiceId));
    }
  };

  useEffect(() => {
    applyFilter();
  }, [invoiceData]);

  useEffect(() => {
    if (successDelete === undefined || successDelete === "") {
    } else {
      applyFilter();
      dispatch({
        type: INVOICE_DELETE_RESET,
      });
    }
  }, [successDelete]);

  return (
    <>
      <Header pageName="Invoice Dashboard" />
      <LeftComponent>
        <div className="content-body">
          <div className="container-fluid">
            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input
                      type="text"
                      name="searchtxt"
                      placeholder="Search Invoice..."
                      value={invoiceData.searchtxt}
                      onChange={(e) => {
                        handleChange(e);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          applySearchFilter();
                        }
                      }}
                    />
                    <i
                      className="fas fa-filter mob-nav-open"
                      onClick={applySearchFilter}
                    ></i>
                  </div>
                  {/* <!-- /filter-in-mob-view --> */}

                  <div className="add-filter">
                    <div className="filter-title  filter-title-mob">
                      <h5>Filter Invoices </h5>
                      <button className="mob-nav-open">☰</button>
                    </div>
                    <div className="filter-body filter-body-mob custom-scroll-right pt-0">
                      <div className="sticky pt-2">
                        <h6>
                          <strong>
                            <a
                              href="!#"
                              onClick={applyOverdueInvoice}
                              className={
                                chkVal == "overdue" ? "clFilter" : "clFilterNo"
                              }
                            >
                              Overdue Invoices
                            </a>
                          </strong>
                        </h6>
                        <br />
                        <h6>
                          <strong>
                            <a
                              href="!#"
                              onClick={applyDueTodayInvoice}
                              className={
                                chkVal == "duetoday" ? "clFilter" : "clFilterNo"
                              }
                            >
                              Due Today Invoices
                            </a>
                          </strong>
                        </h6>

                        <br />
                        <h6>
                          <strong>
                            <a
                              href="!#"
                              onClick={(e) => {
                                applyAllInvoice(e);
                                setChkVal("allinvoices");
                              }}
                              className={
                                chkVal == "allinvoices"
                                  ? "clFilter"
                                  : "clFilterNo"
                              }
                            >
                              All Invoices
                            </a>
                          </strong>
                        </h6>

                        {loadingTotal ? (
                          <>
                            <p>loading...</p>
                          </>
                        ) : // invoicesTotal[0].totalinvoices && <p>Showing {invoicesTotal[0].totalinvoices} Invoices</p>
                        invoicesTotal ? (
                          invoicesTotal > 0 ? (
                            <p>Showing {invoicesTotal} Invoices</p>
                          ) : (
                            <p>No Invoice Found</p>
                          )
                        ) : (
                          <p>No Invoice Exist!</p>
                        )}

                        {/* <h6><strong> All Filter</strong></h6> */}

                        <button
                          className="btn btn-sm btn-deep-orange"
                          onClick={resetFilter}
                        >
                          Reset filters
                        </button>
                        {/* <br />
                        <button
                          className="btn btn-sm btn-deep-orange"
                        >
                          {" "}
                          Apply filters
                        </button> */}
                      </div>

                      <ul className="modify-filter-title">
                        <li>University:</li>
                        <li>
                          <select
                            className="form-control"
                            name="university"
                            value={invoiceData.university}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          >
                            <option value="">--Select--</option>
                            <Universities />
                          </select>
                        </li>
                        <li>Invoice Status:</li>
                        <li>
                          <select
                            className="form-control"
                            name="invoiceStatus"
                            value={invoiceData.invoiceStatus}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          >
                            <option value="">--Select--</option>
                            {InvoiceStatusJson.map((isData) => (
                              <option value={isData?.id}>{isData?.name}</option>
                            ))}
                          </select>
                        </li>

                        {chkVal === "allinvoices" ? (
                          <>
                            <li>
                              Invoice Due Date <br />
                              From:
                            </li>
                            <li>
                              <input
                                type="date"
                                className="form-control"
                                name="invoiceFrom"
                                value={invoiceData.invoiceFrom}
                                onChange={(e) => {
                                  setInvoices(e);
                                }}
                              />
                            </li>
                            <li>To:</li>
                            <li>
                              <input
                                type="date"
                                className="form-control"
                                name="invoiceTo"
                                value={invoiceData.invoiceTo}
                                onChange={(e) => {
                                  setInvoices(e);
                                }}
                              />
                            </li>
                          </>
                        ) : (
                          <></>
                        )}

                        <li>
                          Created Date <br />
                          From:
                        </li>
                        <li>
                          <input
                            type="date"
                            className="form-control"
                            name="createdFrom"
                            value={invoiceData.createdFrom}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          />
                        </li>
                        <li>To:</li>
                        <li>
                          <input
                            type="date"
                            className="form-control"
                            name="createdTo"
                            value={invoiceData.createdTo}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          />
                        </li>

                        <li>
                          Payment Due Date <br />
                          From:
                        </li>
                        <li>
                          <input
                            type="date"
                            className="form-control"
                            name="paymentFrom"
                            value={invoiceData.paymentFrom}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          />
                        </li>
                        <li>To:</li>
                        <li>
                          <input
                            type="date"
                            className="form-control"
                            name="paymentTo"
                            value={invoiceData.paymentTo}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          />
                        </li>
                        <li>Invoiced Country:</li>
                        <li>
                          <select
                            className="form-control"
                            name="countryId"
                            value={invoiceData.countryId}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          >
                            <option value="">--Select--</option>
                            <option value="108">India</option>
                            <option value="13">Australia</option>
                            <option value="171">Nepal</option>
                          </select>
                        </li>

                        <li>Destination:</li>
                        <li>
                          <select
                            className="form-control"
                            name="destinationId"
                            value={invoiceData.destinationId}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          >
                            <option value="">--Select--</option>
                            <Country />
                          </select>
                        </li>

                        <li>Branch:</li>
                        <li>
                          <select
                            className="form-control"
                            name="branchId"
                            value={invoiceData.branchId}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          >
                            <option value="">--Select--</option>
                            <Branch />
                          </select>
                        </li>

                        <li>Partner:</li>
                        <li>
                          <select
                            className="form-control"
                            name="partnerId"
                            value={invoiceData.partnerId}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          >
                            <option value="">--Select--</option>
                            <Partner />
                          </select>
                        </li>

                        <li>Sub Agent:</li>
                        <li>
                          <select
                            className="form-control"
                            name="subagentId"
                            value={invoiceData.subagentId}
                            onChange={(e) => {
                              setInvoices(e);
                            }}
                          >
                            <option value="">--Select--</option>
                            <SubAgent />
                          </select>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-lg-10">
                  <div className="row">
                    <div className="col-md-12 ">
                      <div className="home-table-search float-right d-flex">
                        <div className="input-group search-contacts">
                          <input
                            type="text"
                            id="searchContact"
                            className="form-control ng-pristine ng-valid ng-empty ng-touched"
                            placeholder="Search Invoice"
                            name="searchtxt"
                            value={invoiceData.searchtxt}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                applySearchFilter();
                              }
                            }}
                          />
                          <i
                            className="fa fa-search"
                            aria-hidden="true"
                            onClick={applySearchFilter}
                          ></i>
                        </div>
                        <div className="right-click Create-btn">
                          <Link
                            to="/invoice/create"
                            target="_blank"
                            className="btn create-contact"
                          >
                            Create Invoice
                          </Link>
                        </div>
                      </div>
                      {/* <input type="text" className="form-control sm" />
                                            <Link to="/invoice/create" target="_blank" className='a-btn'>Add Invoice</Link> */}
                    </div>
                  </div>

                  <div className="coctacts-table">
                    <div className="table-responsive custom-scroll-right-bottum">
                      <table className="table table-condensed ">
                        <thead className="t-head-th-bg">
                          <tr>
                            <th className="t-head-fixed">Invoice Id</th>
                            <th className="t-head-fixed">Referral No</th>
                            <th className="t-head-fixed">
                              College / University
                            </th>

                            {/* <th>Course Name</th> */}
                            <th className="t-head-fixed">Partner</th>
                            <th className="t-head-fixed">Contact</th>
                            <th className="t-head-fixed">Invoice Amount </th>
                            <th className="t-head-fixed">Invoice Status</th>
                            <th className="t-head-fixed">Invoice Due Date</th>
                            <th className="t-head-fixed">Payment Due Date</th>
                            <th className="t-head-fixed">Create Date</th>
                            <th className="t-head-fixed"></th>
                          </tr>
                        </thead>
                        <tbody className="table-bordered">
                          {loading ? (
                            <tr>
                              <td colSpan="11">Loading...</td>
                            </tr>
                          ) : (
                            <>
                              {invoices ? (
                                invoices.length > 0 ? (
                                  invoices.map((invo,i) => {
                                    var lnk = `/invoice/edit/${invo.Id}`;
                                    return (
                                      <tr key={i}>
                                        <td>
                                          SED-INV{invo.Id}{" "}
                                          {invo.InvoiceStatus === "Paid" ||
                                          invo.InvoiceStatus === "Withdrawn" ? (
                                            ""
                                          ) : (
                                            <>
                                              {" "}
                                              -{" "}
                                              <Link
                                                to={lnk}
                                                target="_blank"
                                                className="nodecorator"
                                              >
                                                Edit
                                              </Link>
                                            </>
                                          )}
                                        </td>

                                        <td>{invo.Referral_No}</td>
                                        <td>{invo.University_Name}</td>
                                        {/* <td>{invo.Course_Name}</td> */}
                                        <td>{invo.Partner_Agent}</td>
                                        <td>{invo.ContactName}</td>
                                        <td>{invo.Total_with_GST}</td>
                                        <td>{invo.InvoiceStatus}</td>
                                        <td>
                                          {format(
                                            new Date(invo.Invoice_Due_Date),
                                            "dd-MM-yyyy"
                                          ) == "01-01-1970"
                                            ? ""
                                            : format(
                                                new Date(invo.Invoice_Due_Date),
                                                "dd-MM-yyyy"
                                              )}
                                        </td>
                                        <td>
                                          {format(
                                            new Date(invo.Payment_Due_Date),
                                            "dd-MM-yyyy"
                                          ) == "01-01-1970"
                                            ? ""
                                            : format(
                                                new Date(invo.Payment_Due_Date),
                                                "dd-MM-yyyy"
                                              )}
                                        </td>
                                        <td>
                                          {format(
                                            new Date(invo.Created_On),
                                            "yyyy-MM-dd hh:mm a"
                                          )}
                                        </td>
                                        <td>
                                          {user.Result[0].Role_Name ===
                                          "Super Admin" ? (
                                            <button
                                              type="button"
                                              className="btn btn-danger btn-sm"
                                              onClick={(e) =>
                                                handleDeleteInvoice(e, invo.Id)
                                              }
                                            >
                                              Delete
                                            </button>
                                          ) : (
                                            <></>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan="8">{error}</td>
                                  </tr>
                                )
                              ) : (
                                <>
                                  <tr>
                                    <td colSpan="8">{error ? error : ""}</td>
                                  </tr>
                                </>
                              )}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="table-page-details">
                      <div className="row">
                        <div className="col-md-9">
                          <ReactPaginate
                            className="pagination justify-content-center"
                            activeClassName="activeClass"
                            breakLabel="..."
                            nextLabel="Next"
                            nextClassName="nextClass"
                            previousClassName="previousClass"
                            pageClassName="page-item"
                            onPageChange={(e) => applyPageFilter(e)}
                            pageRangeDisplayed={5}
                            pageCount={
                              invoicesTotal
                                ? Math.ceil(
                                    invoicesTotal / invoiceData?.pageSize
                                  )
                                : "1"
                            }
                            previousLabel="Previous"
                            renderOnZeroPageCount={null}
                            pageLinkClassName="page-link"
                          />
                          {/* <div className="page-number">
                                                        <ul className="pagination justify-content-center">
                                                            <li className="page-item">
                                                                <a className="page-link" href="#" tabindex="-1">Previous</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">1</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">2</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">3</a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" href="#">Next</a>
                                                            </li>
                                                        </ul>
                                                    </div> */}
                        </div>
                        <div className="col-md-3 text-center">
                          <div className="page-counter">
                            <label>
                              Showing &nbsp;
                              <select
                                name="pageSize"
                                value={invoiceData.pageSize}
                                onChange={(e) => {
                                  setInvoices(e);
                                }}
                              >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>{" "}
                              of{" "}
                              <span>{invoicesTotal ? invoicesTotal : "0"}</span>{" "}
                              records
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LeftComponent>
    </>
  );
}
